// Generated by packages/client/openapi.ts from API route and deployment metadata.
export const controlPlaneRouting: {
  readonly origins: Readonly<Record<string, string>>;
  readonly routes: readonly { method: string; endpoint: string }[];
} = {
  "origins": {
    "https://api.vrplatform.app": "https://us.api.vrplatform.app",
    "https://api.edge.vrplatform.app": "https://us.api.vrplatform.app",
    "https://staging.api.vrplatform.app": "https://us.staging.api.vrplatform.app",
    "https://staging.api.edge.vrplatform.app": "https://us.staging.api.vrplatform.app",
    "https://us.staging.api.vrplatform.app": "https://us.staging.api.vrplatform.app",
    "https://eu.staging.api.vrplatform.app": "https://us.staging.api.vrplatform.app",
    "https://ap.staging.api.vrplatform.app": "https://us.staging.api.vrplatform.app",
    "https://us.api.vrplatform.app": "https://us.api.vrplatform.app",
    "https://eu.api.vrplatform.app": "https://us.api.vrplatform.app",
    "https://ap.api.vrplatform.app": "https://us.api.vrplatform.app"
  },
  "routes": [
    {
      "method": "GET",
      "endpoint": "/internal/message-overwrites"
    },
    {
      "method": "GET",
      "endpoint": "/internal/operations/accounting-integrity/definition-drafts/{id}"
    },
    {
      "method": "GET",
      "endpoint": "/internal/operations/accounting-integrity/definitions"
    },
    {
      "method": "GET",
      "endpoint": "/internal/operations/accounting-integrity/definitions/{code}"
    },
    {
      "method": "GET",
      "endpoint": "/internal/owner-portals/{hostname}"
    },
    {
      "method": "GET",
      "endpoint": "/internal/owner-portals/{hostname}/providers"
    },
    {
      "method": "GET",
      "endpoint": "/me/teams"
    },
    {
      "method": "POST",
      "endpoint": "/embed-sessions/exchange"
    },
    {
      "method": "POST",
      "endpoint": "/embed-sessions/frame-ancestor-policy"
    },
    {
      "method": "POST",
      "endpoint": "/internal/operations/accounting-integrity/definition-drafts"
    },
    {
      "method": "POST",
      "endpoint": "/internal/operations/accounting-integrity/definition-drafts/{id}/publish"
    },
    {
      "method": "POST",
      "endpoint": "/internal/operations/accounting-integrity/definition-drafts/{id}/validate"
    },
    {
      "method": "POST",
      "endpoint": "/internal/owner-portals/logo"
    },
    {
      "method": "POST",
      "endpoint": "/internal/owner-portals/{hostname}/providers"
    },
    {
      "method": "POST",
      "endpoint": "/owner-portal-previews/end"
    },
    {
      "method": "POST",
      "endpoint": "/owner-portal-previews/exchange"
    },
    {
      "method": "PUT",
      "endpoint": "/internal/operations/accounting-integrity/definition-drafts/{id}"
    },
    {
      "method": "PUT",
      "endpoint": "/internal/operations/grants/users/{userId}"
    },
    {
      "method": "PUT",
      "endpoint": "/internal/owner-portals/{hostname}"
    },
    {
      "method": "PUT",
      "endpoint": "/me/settings"
    }
  ]
};

// Routes the API places by `x-data-region` or path, not by `x-team-id`.
export const requestRegionRoutes: readonly { method: string; endpoint: string }[] = [
  {
    "method": "DELETE",
    "endpoint": "/internal/teams/{teamId}"
  },
  {
    "method": "GET",
    "endpoint": "/internal/memberships/{membershipId}"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases/{caseId}"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases/{caseId}/evidence"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/health"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/runs"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/runs/{runId}"
  },
  {
    "method": "GET",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/work-queue"
  },
  {
    "method": "GET",
    "endpoint": "/internal/teams/billing"
  },
  {
    "method": "GET",
    "endpoint": "/internal/users"
  },
  {
    "method": "GET",
    "endpoint": "/operations"
  },
  {
    "method": "GET",
    "endpoint": "/operations/{id}"
  },
  {
    "method": "GET",
    "endpoint": "/partner/audit-events"
  },
  {
    "method": "GET",
    "endpoint": "/partner/billing"
  },
  {
    "method": "GET",
    "endpoint": "/partner/connections"
  },
  {
    "method": "GET",
    "endpoint": "/partner/listings"
  },
  {
    "method": "GET",
    "endpoint": "/partner/owner-statements"
  },
  {
    "method": "GET",
    "endpoint": "/partner/users"
  },
  {
    "method": "GET",
    "endpoint": "/partner/users/{id}"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/recurring-fee-setup"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/reservation-line-mappings"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/statements/account-mappings"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/statements/listing-mappings"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/statements/owners"
  },
  {
    "method": "GET",
    "endpoint": "/partner/vri-to-vrt/statements/payouts"
  },
  {
    "method": "GET",
    "endpoint": "/teams"
  },
  {
    "method": "GET",
    "endpoint": "/teams/issues"
  },
  {
    "method": "GET",
    "endpoint": "/teams/lookup"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases/{caseId}/claim"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases/{caseId}/release"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/cases/{caseId}/review"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/previews"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/cancel"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/complete"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/stages/{ordinal}/apply"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/stages/{ordinal}/approve"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/stages/{ordinal}/dry-run"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/stages/{ordinal}/request-approval"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/repair-plans/{planId}/stages/{ordinal}/verify"
  },
  {
    "method": "POST",
    "endpoint": "/internal/operations/accounting-integrity/regions/{region}/shadow-runs"
  },
  {
    "method": "POST",
    "endpoint": "/partner/vri-to-vrt"
  },
  {
    "method": "POST",
    "endpoint": "/partner/vri-to-vrt/booking-channels"
  },
  {
    "method": "POST",
    "endpoint": "/partner/vri-to-vrt/statements"
  }
];
